import { render, staticRenderFns } from "./anonymous_reg_form.vue?vue&type=template&id=dbc9f994&"
import script from "./anonymous_reg_form.vue?vue&type=script&lang=js&"
export * from "./anonymous_reg_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports